import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../AuthContext";
import { privateAxios } from "../utils/axios";
import usePermissions from "../hooks/usePermissions";
import toast from "react-hot-toast";

import SalesReportModal from "../components/SalesReportModal";

function GenerateReport() {

  const [suppliers, setSuppliers] = useState([]);

  const [salesReportData, setSalesReportData] = useState(null);
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);

 

  // Sales Report Filters
  const [salesFilters, setSalesFilters] = useState({
    branchName: "",
    receiverPhone: "",
    productId: "",
    startDate: "",
    endDate: "",
  });

  const authContext = useContext(AuthContext);
  
  const { canRead } = usePermissions();

  const canAccessExpenseReport = canRead("expense-report");

  useEffect(() => {
    fetchSuppliersData();
  }, []);

  // Fetch suppliers data
  const fetchSuppliersData = () => {
    privateAxios
      .get(`/suppliers/all`)
      .then((response) => {
        if (response.data.success) {
          setSuppliers(response.data.data);
        }
      })
      .catch((err) => console.log(err));
  };





  // Generate Sales Report
  const handleGenerateSalesReport = async () => {
    setIsGeneratingReport(true);
    try {
      const queryParams = new URLSearchParams();
      if (salesFilters.branchName) {
        queryParams.append("branchName", salesFilters.branchName);
      }
      if (salesFilters.productId) {
        queryParams.append("productId", salesFilters.productId);
      }
      if (salesFilters.startDate) {
        queryParams.append("startDate", salesFilters.startDate);
      }
      if (salesFilters.endDate) {
        queryParams.append("endDate", salesFilters.endDate);
      }

      const response = await privateAxios.get(
        `/expenses/generate-report?${queryParams}`
      );
      if (response.data.success) {
        setSalesReportData(response.data.data);
        toast.success("Report generated successfully");
      }
    } catch (error) {
      console.error("Error generating sales report:", error);
      toast.error("Failed to generate sales report");
    } finally {
      setIsGeneratingReport(false);
    }
  };

  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12">
        {/* Page Header */}
        <div className="bg-white rounded-xl border border-gray-200 p-6 w-full mt-6 mb-8">
          <div className="flex justify-between items-start">
            <div>
              <span className="font-bold text-xl text-gray-900">
                Expense Report
              </span>
              <div className="text-gray-500 text-sm mt-1">
               Track the purchase details by suppliers and date ranges
              </div>
            </div>
          </div>
        </div>

          <SalesReportModal
            filters={salesFilters}
            setFilters={setSalesFilters}
            reportData={salesReportData}
            isGenerating={isGeneratingReport}
            onGenerate={handleGenerateSalesReport}
          />
       
      </div>
    </div>
  );
}

export default GenerateReport;
